import { useForm } from 'react-hook-form';
import { useCommonTranslation } from '../../../../hooks/useCommonTranslation';
import { Box, styled } from '@mui/material';
import { forwardRef, useEffect, useImperativeHandle } from 'react';
import { InventoryManagementSettingFormRef } from './InventoryManagementDialog';
import CurrencyInputField from '../../../forms/CurrencyInputField';

const StyledBox = styled(Box)(({ theme }) => ({
  width: 123,
}));

interface SizeOfPackageFormProps {
  value?: number;
  onValidityChange?: (valid: boolean) => void;
  isReadOnly?: boolean;
}

export const SizeOfPackageForm = forwardRef<
  InventoryManagementSettingFormRef,
  SizeOfPackageFormProps
>(({ value, onValidityChange, isReadOnly }, ref) => {
  const t = useCommonTranslation();
  const {
    control,
    setValue,
    getValues,
    trigger,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
    defaultValues: { targetPackageSize: '' },
  });
  const requiredFieldMessage = t('common.requiredField');

  useImperativeHandle(ref, () => ({
    getValues,
    triggerValidation: () => trigger(),
    isValid,
  }));

  useEffect(() => {
    if (value != null) {
      setValue('targetPackageSize', `${value * 100}`);
    }
  }, [value]);

  useEffect(() => {
    onValidityChange?.(isValid);
  }, [isValid, onValidityChange]);

  return (
    <StyledBox>
      {/* Use currency field because it supports adding the percent symbol suffix */}
      <CurrencyInputField
        name="targetPackageSize"
        control={control}
        prefix=""
        suffix=" %"
        rules={{
          max: {
            value: 100,
            message: t('inventoryManagement.rangeError'),
          },
        }}
        currencyInputProps={{
          allowNegativeValue: false,
        }}
        textFieldProps={{
          label: `${t('inventoryManagement.providerCapacity')}`,
          InputProps: {
            readOnly: isReadOnly,
          },
        }}
      />
    </StyledBox>
  );
});
